import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonCallsActionCreators from '../../../actionCreators/common';
import CommonLoader from './Loader';
import './Shortlist.scss';

class Shortlist extends PureComponent {

    static propTypes = {
        shortListData: PropTypes.object,
        wishlistTrue: PropTypes.bool,
        checkId: PropTypes.func,
        login: PropTypes.bool,
        shortListBool: PropTypes.bool,
        wishListDeleteSuccess: PropTypes.bool,
        wishListAddSuccess: PropTypes.bool,
        isWishlistCount: PropTypes.number
    };

    constructor(props) {
        super(props);
        this.toggleMe = this.toggleMe.bind(this);
        this.deleteWishListAll = this.deleteWishListAll.bind(this, '');
        this.deleteWishList = this.deleteWishList.bind(this);
        this.isActionDeleteAll = false;
    }

    componentDidUpdate(prevProps) {
        const { commonCallsAction, wishListDeleteSuccess, wishListAddSuccess, saveWishlist } = this.props;
        if (prevProps.wishListDeleteSuccess !== wishListDeleteSuccess) {
            if (wishListDeleteSuccess && this.props.isWishlistCount) {
                commonCallsAction.shortlist('', 'get', '?attributes=true');
                return;
            }
            commonCallsAction.shortListType(false);
            if (this.isActionDeleteAll) {
                this.props.checkId();
                this.isActionDeleteAll = false;
            }
        } else if (prevProps.wishListAddSuccess !== wishListAddSuccess) {
            if (wishListAddSuccess && saveWishlist) {
                commonCallsAction.shortlist('', 'get', '?attributes=true');
                return;
            }
            commonCallsAction.showWishlist(true);
            commonCallsAction.shortListType(false);
        }
    }

    deleteWishListAll(id) {
        const { commonCallsAction } = this.props;
        commonCallsAction.shortListType(true);
        /* omniture start */
        const pid = [];
        if (this.props.shortListData.result.numberOfProducts > 0) {
            if (this.props.shortListData.result.productList) {
                this.props.shortListData.result.productList.forEach(data => {
                    pid.push(data.id);
                });
            }
        }
        if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.Listing.click.clearList(this.props.login, pid.toString());
        /* omniture end */
        this.isActionDeleteAll = true;
        commonCallsAction.shortlist('', 'delete', `/${id}`);
    }

    deleteWishList(value) {
        const { commonCallsAction } = this.props;
        commonCallsAction.shortListType(true);
        if (window.dtm.LenskartRewamp) window.dtm.LenskartRewamp.Listing.click.removeProdcutShortlist(this.props.login, value);
        this.isActionDeleteAll = false;
        commonCallsAction.shortlist(value, 'delete', `/${value}`);
    }

    toggleMe() {
        const { commonCallsAction } = this.props;
        if (this.props.wishlistTrue === false) {
            commonCallsAction.showWishlist(true);
        } else {
            commonCallsAction.showWishlist(false);
        }
    }

    render() {
        let shortlistNumberofProduct = 0;
        if (!this.props.wishlistTrue) {
            return false;
        }
        if (this.props.shortListData) {
            shortlistNumberofProduct = this.props.shortListData.result.numberOfProducts;
        }
        return (
            <div className="wishlist col-lg-12 col-md-12 col-sm-12">
                {this.props.shortListData && this.props.shortListData.result.productList.length === 0 ?
                    <div className={`wishlist_fixed ${this.props.wishlistTrue}`} id="wishlistView">
                        <div className="wishlist_header" onClick={this.toggleMe}>
                            <a className="wishlist_header_text">
                                PRODUCTS (<span id="quickwishlist_cnt">0</span>)
                        </a>
                        </div>
                        <div className="wishlist_noProducts" id="quickwishlist">
                            <p className="wishlist_noProducts_info">
                                You have not selected any product to compare. <br></br> Please add products of your choice and view here.
                        </p>
                        </div>
                    </div> :
                    <div className={`wishlist_fixed  ${this.props.wishlistTrue}`} id="wishlistView">
                        {this.props.shortListBool && <CommonLoader />}
                        <div className="wishlist_header" onClick={this.toggleMe}>
                            <a className="wishlist_header_text">
                                PRODUCTS (<span id="quickwishlist_cnt">{shortlistNumberofProduct <= 50 ? shortlistNumberofProduct : 50}</span>)
                        </a>
                        </div>
                        <div className="wishlist_products">
                            {this.props.shortListData && this.props.shortListData.result.productList && this.props.shortListData.result.productList.map((value, index) => {
                                return (
                                    <div key={index + 1}>
                                        {(index <= 49) && <div key={value.id} className="wishlist_products_item">
                                            <a className="icon-rcross" onClick={() => this.deleteWishList(value.id)}><span>&times;</span></a>
                                            <a title={value.brandName} href={value.productUrl}>
                                                <div className="wishlist_products_item_image">
                                                    <img alt="" src={value.productImageUrl} width="48" height="48" />
                                                </div>
                                                <div className="wishlist_products_item_details">
                                                    <h5 className="wishlist_products_item_details_brandName">{value.brandName}</h5>
                                                    {value.prices.length === 3 ? <span><s className="text-link">Rs {value.prices[1].price}</s><span className="wishlist_products_item_details_price margin-l5">Rs {value.prices[2].price}</span></span> :
                                                        <span className="wishlist_products_item_details_price">Rs {value.prices[1].price}</span>}
                                                </div>
                                            </a>
                                        </div>}
                                    </div>
                                );
                            })}
                        </div>
                        <div className={this.props.shortListBool ? 'wishlist_viewall wishlist_shortDisable' : 'wishlist_viewall'}>
                            <a className="wishlist_viewall_btn" onClick={this.deleteWishListAll}>Clear List</a>
                        </div>
                    </div>}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    wishListDeleteSuccess: state.common.wishListDeleteSuccess,
    isWishlistCount: state.common.isWishlistCount,
    shortListBool: state.common.shortListBool,
    saveWishlist: state.common.saveWishlist,
    wishListAddSuccess: state.common.wishListAddSuccess,
    login: state.common.login
});

function mapDispatchToProps(dispatch) {
    return {
        commonCallsAction: bindActionCreators(commonCallsActionCreators, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Shortlist);
